export default __webpack_public_path__ + "static/media/i-contato.2e8da8be.png";